<template>
  <ValidationObserver slim>
    <b-tr>
      <b-td stacked-heading="Camera" v-if="showRoom">Camera {{ room }}</b-td>
      <b-td stacked-heading="Titlu">
        <ValidationProvider
            name="Titlu"
            :rules="{ required: true }"
            :vid="id + 'title'"
            v-slot="vContext"
            v-if="pax.age === 'adult'"
          >
          <b-form-group>
            <b-form-select
              size="sm"
              v-model="pax.title"
              :options="titles"
              :state="getValidationState(vContext)"
              aria-describedby="title-live-feedback"
            >
            </b-form-select>
            <b-form-invalid-feedback id="title-live-feedback">{{ vContext.errors[0] }}</b-form-invalid-feedback>
          </b-form-group>
        </ValidationProvider>
        <span v-else>{{pax.title}}</span>
      </b-td>
      <b-td stacked-heading="Nume">
        <ValidationProvider
            name="Nume"
            :rules="{ required: true }"
            :vid="id + 'lname'"
            v-slot="vContext"
          >
          <b-form-group>
            <b-form-input
              type="text"
              :name="'nume'"
              placeholder="Nume *"
              class="form-control form-control-sm"
              v-model="pax.lname"
              size="sm"
              :state="getValidationState(vContext)"
              aria-describedby="lname-live-feedback"
            ></b-form-input>
            <b-form-invalid-feedback id="lname-live-feedback">{{ vContext.errors[0] }}</b-form-invalid-feedback>
          </b-form-group>
        </ValidationProvider>
      </b-td>
      <b-td stacked-heading="Prenume">
        <ValidationProvider
            name="Prenume"
            :rules="{ required: true }"
            :vid="id + 'fname'"
            v-slot="vContext"
          >
          <b-form-group>
            <b-form-input
              type="text"
              :name="'prenume'"
              placeholder="Prenume *"
              class="form-control form-control-sm"
              v-model="pax.fname"
              size="sm"
              :state="getValidationState(vContext)"
              aria-describedby="fname-live-feedback"
            ></b-form-input>
            <b-form-invalid-feedback id="fname-live-feedback">{{ vContext.errors[0] }}</b-form-invalid-feedback>
          </b-form-group>
        </ValidationProvider>
      </b-td>
      <b-td stacked-heading="Varsta">{{ pax.age }}</b-td>
      <b-td stacked-heading="Data nastere">
        <ValidationProvider
            name="Data nastere"
            :rules="{ required: true, validDate: { min: fromMin, max: to } }"
            :vid="id + 'dob'"
            v-slot="vContext"
          >
          <b-form-group id="hello-date-picker">
            <DatePicker
              v-model="dob"
              :state="getValidationState(vContext)"
              :defaultValue="defaultDate"
              :notBefore="from"
              :notAfter="to"
              size="sm"
              placeholder="zz/ll/aaaa"
              aria-describedby="dob-live-feedback"
            ></DatePicker>
            <b-form-invalid-feedback id="dob-live-feedback">{{ vContext.errors[0] }}</b-form-invalid-feedback>
          </b-form-group>
        </ValidationProvider>
      </b-td>
    </b-tr>
  </ValidationObserver>
</template>
<style>
  fieldset {
    margin-bottom: 0px!important;
  }
  #hello-date-picker input.form-control.form-control-md  {
    height: calc(1.5em + 0.5rem + 2px);
    font-size: .875rem;
  }
  #hello-date-picker .input-group-append .btn-md {
    padding: 0.25rem 0.5rem;
    font-size: 0.875rem;
    line-height: 1.5;
    border-radius: 0.2rem;
  }
</style>

<script>
import moment from 'moment'
import DatePicker from 'b2b-common/components/datepicker'
import { titles } from '@/shared/utils'
import validation from 'b2b-common/mixins/validation'

export default {
  name: 'PaxForm',
  mixins: [validation],
  props: ['value', 'room', 'travelDate', 'id'],
  components: { DatePicker },
  data () {
    return {
      pax: this.value,
      titles: titles.filter(el => !['Chd', 'Inf'].includes(el)).map(el => ({ value: el, text: el }))
    }
  },
  computed: {
    showRoom () {
      return this.room !== null && this.room !== undefined
    },
    dob: {
      get () {
        if (!this.pax.bdate) return null
        return moment(this.pax.bdate, 'DD-MM-YYYY').toDate()
      },
      set (val) {
        if (val) this.pax.bdate = moment(val).format('DD-MM-YYYY')
        else this.pax.bdate = null
      }
    },
    defaultDate () {
      if (this.pax.age === 'adult') return moment(this.travelDate).subtract(30, 'years').toDate()
      return moment(this.travelDate).subtract(this.pax.age, 'years').subtract(6, 'months').toDate()
    },
    from () {
      if (this.pax.age === 'adult') return null
      return moment(this.travelDate).subtract(this.pax.age + 1, 'years').add(1, 'days').toDate()
    },
    fromMin () {
      if (this.pax.age === 'adult') return null
      return moment(this.travelDate).subtract(this.pax.age + 1, 'years').toDate()
    },
    to () {
      if (this.pax.age === 'adult') return moment(this.travelDate).subtract(18, 'years').add(1, 'days').toDate()
      return moment(this.travelDate).subtract(this.pax.age, 'years').toDate()
    }
  }
}
</script>
